import ko from "knockout";
import $ from "jquery";
import myFlowLocator from "flow/utils/myFlowLocator";
import register from "flow/knockout/register";

register.registerKnockoutBinding("slideRightVisible", {
    init: function (element, valueAccessor) {
        // Initially set the element to be instantly visible/hidden depending on the value
        const value = valueAccessor();
        $(element).toggle(ko.utils.unwrapObservable(value)); // Use "unwrapObservable" so we can handle values that may or may not be observable
    },
    update: function (element, valueAccessor, _allBindingsAccessor, _viewModel, bindingContext) {
        // Whenever the value subsequently changes, slowly fade the element in or out
        const value = valueAccessor();

        const myFlow = myFlowLocator.getMyFlow(bindingContext.$root);

        const showMe = ko.utils.unwrapObservable(value);

        if (showMe) {
            const onSlideDone = function () {
                myFlow.requestFocus();
            };

            $(element).show("slide", { direction: "right", easing: "easeOutQuart" }, 800, onSlideDone);
        } else {
            $(element).hide("slide", { direction: "right", easing: "easeOutQuart" }, 800);
        }
    }
});
